export default __webpack_public_path__ + "static/media/RituBirla.090dc5d7.png";